export default __webpack_public_path__ + "static/media/illustrationBg1.9d46defe.png";